module.exports = __webpack_public_path__ + "static/img/quit.15f0d02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quit.svg
// module id = FbOE
// module chunks = 1